import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import { Text as ChakraText } from '@chakra-ui/react';
import themeStyles from '../theme/styles';
import { toArray } from '../utils/core';

const { textStyles: themeTextStyles } = themeStyles;

// NOTE: These are because the TextStyles prop is currently broken as of Chakra >1.4
const Text = ({ textStyle, style, as, children = [], asHtml, ...props }) => {
  const [firstChild, ...otherChildren] = toArray(children);
  const textStyles = { ...themeTextStyles[textStyle], ...style };
  const html = {
    ...(asHtml && {
      dangerouslySetInnerHTML: {
        __html: `${firstChild}${otherChildren.length ? otherChildren.map(renderToStaticMarkup) : ''}`,
      },
    }),
  };
  return (
    <ChakraText as={as} {...textStyles} {...html} {...props}>
      {!asHtml ? children : undefined}
    </ChakraText>
  );
};

export default Text;
